import {
  SimpleMenuItemOptions,
  SubMenuItemOptions,
} from '@modules/common/components/KebabMenu/types';
import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from '@mui/material';

interface FlatMenuListItemProps {
  listItem: SimpleMenuItemOptions | SubMenuItemOptions;
  menuItemIndex: number;
  onMenuClose: () => void;
  shouldShowDividers?: boolean;
}

export const FlatMenuListItem = ({
  listItem,
  menuItemIndex,
  onMenuClose,
  shouldShowDividers,
}: FlatMenuListItemProps) => {
  const hasSubMenu = 'subItems' in listItem;

  const onMenuClick = () => {
    if ('onClick' in listItem) {
      listItem.onClick();
    }
    onMenuClose();
    return;
  };

  if (hasSubMenu) {
    const subMenuItems = listItem.subItems;
    const onSubItemMenuClick = (
      subMenuItem: SimpleMenuItemOptions | SubMenuItemOptions,
    ) => {
      if ('onClick' in subMenuItem) {
        subMenuItem.onClick();
      }
      onMenuClose();
      return;
    };

    return (
      <>
        {shouldShowDividers && <Divider />}
        <Typography variant="body2" pl={2} color="text.disabled">
          {listItem.label}
        </Typography>
        {subMenuItems.map((subMenuItem, subMenuItemIndex) => (
          <MenuItem
            onClick={() => onSubItemMenuClick(subMenuItem)}
            key={subMenuItemIndex}
          >
            {subMenuItem.icon && (
              <ListItemIcon>{subMenuItem.icon}</ListItemIcon>
            )}
            <ListItemText>{subMenuItem.label}</ListItemText>
          </MenuItem>
        ))}
        {shouldShowDividers && <Divider />}
      </>
    );
  }

  return (
    <MenuItem onClick={onMenuClick} key={menuItemIndex}>
      {listItem.icon && <ListItemIcon>{listItem.icon}</ListItemIcon>}
      <ListItemText>{listItem.label}</ListItemText>
    </MenuItem>
  );
};
